import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import Filter from './filter';
import { path, propOr, either, isNil, isEmpty, not, call, ifElse, equals, always, prop } from 'ramda';
import Dropdown from './dropdown';
import { FontIcon } from 'material-ui';
import ReplyIcon from 'material-ui/svg-icons/content/reply';

const isNilOrEmpty = either(isEmpty, isNil);

const TitleContainer = props => {
  const {
    MMReducer,
    MMPartnerReducer,
    updateMMProp,
    updateMMPartnerProp,
    downloadSingleFile,
    updateMM,
    selectedFilesUrls,
    isEditable,
    containerStateForViewers, // for viewers
    updateStateForViewers, // for viewers
    isSupplier,
    forLocationOrProductPages,
    findPhotosForTag, // for location and product pages
    user,
  } = props;

  const sharedProps = {
    updateMMProp,
    isEditable,
    isSupplier,
    updateStateForViewers: !isEditable ? updateStateForViewers : undefined,
    containerStateForViewers: !isEditable ? containerStateForViewers : undefined,
    forLocationOrProductPages,
    findPhotosForTag,
  };

  const checkIfSupplier = isSupplier ?
    {
      height: '48px',
      fontSize: '20px',
      color: 'rgba(0, 0, 0, 0.87)',
      backgroundColor: (MMPartnerReducer.sendToPartners || MMPartnerReducer.sendingMM || MMReducer.managingTags) ? '#00bcd4' : '#f5f5f5',
      padding: '2%',
      width: '100%',
    } : {
      color: 'rgba(0, 0, 0, 0.87)',
      fontSize: 'calc(12px + 0.5vw)',
      fontWeight: '600',
      marginBottom: '45px',
      border: '1px solid transparent',
      backgroundColor: (MMPartnerReducer.sendToPartners || MMPartnerReducer.sendingMM) ? '#00bcd4' : '',
      height: (MMPartnerReducer.sendToPartners || MMPartnerReducer.sendingMM) ? '48px' : '',
      padding: (MMPartnerReducer.sendToPartners || MMPartnerReducer.sendingMM) ? '0 2%' : '',
    };

  const checkHeader = () => {
    if (MMPartnerReducer.sendToPartners || MMPartnerReducer.sendingMM) {
      return (
        <FontIcon
          className="tc-icon-arrow_back"
          style={{ color: '#ffffff', cursor: 'pointer' }}
          onTouchTap={() => updateMMPartnerProp({
            sendToPartners: false,
            partnersToSendTo: [],
            filteredConnections: [],
            addPartnersMethod: '',
            showSelectMethod: false,
            showReview: false,
            individualCompanyName: '',
            individualEmail: '',
            searchField: '',
            selectedExistingPartners: [],
          })}
        />
      );
    } else if (MMReducer.managingTags) {
      return (
        <FontIcon
          className="tc-icon-arrow_back"
          style={{ color: '#ffffff', cursor: 'pointer' }}
          onTouchTap={() => updateMMProp({
            managingTags: false,
            tagsStep: 1,
            tags: [],
            selectedFiles: [],
          })}
        />
      );
    }
    return (<span>Marketing Materials</span>);
  };

  return (
    <div style={checkIfSupplier}>
      <span style={isSupplier ? {} : { float: 'left', marginTop: '10px' }}>
        {checkHeader()}
      </span>
      <span style={{ float: 'right', margin: '-9px -5px 0 0', display: 'inline-block' }}>
        <div style={{
          color: (MMReducer.managingTags || MMPartnerReducer.sendToPartners || MMPartnerReducer.sendingMM) ? '#ffffff' : 'rgba(0, 0, 0, 0.54)',
          display: 'inline-block',
          float: 'left',
          margin: isSupplier ? '10px 20px 0 0' : '17px 20px 0 0',
          fontSize: '16px' }}
        >
          {selectedFilesUrls.length > 0 && isNilOrEmpty(MMReducer.searchField) ?
            `${selectedFilesUrls.length} of ${not(isNilOrEmpty(findPhotosForTag)) ? prop('length', findPhotosForTag) : path(['media', 'length'], MMReducer)} selected` : ''}
        </div>
        <div style={{ color: MMReducer.managingTags ? '#ffffff' : 'rgba(0, 0, 0, 0.54)', display: 'inline-block', float: 'left', margin: isSupplier ? '10px 20px 0 0' : '17px 20px 0 0', fontSize: '16px' }}>
          {
            call(ifElse(
              equals(true),
                () => call(ifElse(
                  equals(true),
                    always(`${selectedFilesUrls.length} of ${path(['filteredMedia', 'length'], MMReducer)} selected`),
                  always(`${path(['filteredMedia', 'length'], MMReducer)} ${equals(path(['filteredMedia', 'length'], MMReducer), 1) ? 'file' : 'files'} found`)
                ), Boolean(selectedFilesUrls.length)),
              always('')
            ), MMReducer.filteredMedia && not(isNilOrEmpty(MMReducer.searchField)))
          }
        </div>
        {
          isEditable ?
          <div style={{ float: 'left', marginTop: isSupplier ? '5px' : '14px', cursor: 'pointer' }}>
            {
              path(['media', 'length'], MMReducer) > 0 && !MMReducer.managingTags && !MMPartnerReducer.sendToPartners && !MMPartnerReducer.sendingMM ?
                <span id="shareMarketingMaterial">
                  <FontIcon
                    onTouchTap={() => {
                      window.location = `${
                        process.env.NEW_SYSTEM_URL
                      }/partner-management/send-assets?go_back_to=${window.location.href}&jwt=${localStorage.getItem('jwt')}&open_asset_type=mms`;
                    }}
                  >
                    <ReplyIcon
                      className="flip-icon"
                      color={'#00bcd4'}
                      style={{ verticalAlign: 'bottom' }}
                    />
                    <span style={{ fontSize: '15px', color: 'rgba(0, 0, 0, 0.54)' }}>Share</span>
                  </FontIcon>
                </span> : <span/>
            }
          </div> : <span/>
        }
        <div style={{ float: 'left' }}>
          {
            path(['media', 'length'], MMReducer) > 0 && !MMReducer.managingTags && !MMPartnerReducer.sendToPartners && !MMPartnerReducer.sendingMM ?
              <Filter
                filterByMediaType={isEditable ? MMReducer.filterByMediaType : propOr('All File Types', 'filterByMediaType', containerStateForViewers)}
                {...sharedProps}
              /> : <span/>
          }
        </div>
        <div style={{ float: 'right', marginTop: '17px' }}>
          {
            (MMReducer.managingTags || MMPartnerReducer.sendToPartners || MMPartnerReducer.sendingMM) ? <span/> :
              <Dropdown
                downloadSingleFile={downloadSingleFile}
                updateMM={updateMM}
                updateMMPartnerProp={updateMMPartnerProp}
                selectedFilesUrls={selectedFilesUrls}
                {...sharedProps}
              />
          }
        </div>
      </span>
    </div>
  );
};

TitleContainer.propTypes = {
  MMReducer: PropTypes.object,
  updateMMProp: PropTypes.func,
  updateMMPartnerProp: PropTypes.func,
  downloadSingleFile: PropTypes.func,
  updateMM: PropTypes.func,
  selectedFilesUrls: PropTypes.array,
  isEditable: PropTypes.bool,
  containerStateForViewers: PropTypes.object,
  updateStateForViewers: PropTypes.func,
  isSupplier: PropTypes.bool,
  MMPartnerReducer: PropTypes.object,
  forLocationOrProductPages: PropTypes.bool,
  findPhotosForTag: PropTypes.array,
  user: PropTypes.object,
};

const mapStateToProps = ({ marketingMaterials, user }) => ({
  MMReducer: marketingMaterials.mainReducer.toJS(),
  MMPartnerReducer: marketingMaterials.partnerReducer.toJS(),
  user: user.toJS(),
});

export default connect(mapStateToProps)(TitleContainer);



// WEBPACK FOOTER //
// ./src/app/components/marketing-materials/title-bar/title-container.jsx